import React from 'react';
import { OrganizationUser } from 'src/common/interfaces/organization/user.interface';
import { withFixedLoadingSpinner } from 'src/common/components/loading-spinner/hooks/with-loading-spinner';
import { DashboardHomeJourneys, DashboardHomeJourneysPropsInterface } from './journeys';
import UpgradePricingModal from 'src/pricing/UpgradePricingModal';

interface DashboardHomeSectionComponentProps
  extends Pick<
    DashboardHomeJourneysPropsInterface,
    'pagination' | 'isListLoading' | 'journeys' | 'searchInputValue' | 'hideDashboardContent' | 'activeTableSortType'
  > {
  currentUser: OrganizationUser;
}

const DashboardHomeSectionComponent = ({
  journeys,
  currentUser,
  hideDashboardContent,
  searchInputValue,
  pagination,
  isListLoading,
  activeTableSortType,
}: DashboardHomeSectionComponentProps) => {
  const [userFirstName] = currentUser.name.split(' ');

  return (
    <>
      <div className='text-bedrock-serif-h1 max-w-[812px]'>Welcome to Journey, {userFirstName}.</div>
      {/* {!currentOrganization.has_access_to_neue_only && (
        <CreateJourneyCards containerClassName='mt-10 gap-5' fromSidebar={false} />
      )} */}
      <DashboardHomeJourneys
        activeTableSortType={activeTableSortType}
        isListLoading={isListLoading}
        hideDashboardContent={hideDashboardContent}
        pagination={pagination}
        journeys={journeys}
        searchInputValue={searchInputValue}
      />
      <UpgradePricingModal />
    </>
  );
};

export const DashboardHomeSection =
  withFixedLoadingSpinner<DashboardHomeSectionComponentProps>(DashboardHomeSectionComponent);
